import React,{useEffect} from 'react'
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import './index.css'
function AboutWork() {
const controls1 = useAnimation();
const controls2 = useAnimation();

const { ref: ref1, inView: inView1 } = useInView({
  threshold: 0.1, // Trigger when section 1 is 50% in view
  rootMargin: "-10% 0% -50% 0%", // Adding a margin of -100px to the top and bottom
});

// useInView hook for about-2 with margin
const { ref: ref2, inView: inView2 } = useInView({
  threshold: 0.5, // Trigger when section 2 is 50% in view
  rootMargin: "-10% 0% -50% 0%", // Adding a margin of -100px to the top and bottom
});

// useEffect to control animations
useEffect(() => {
  if (inView2) {
    // controls1.start("hidden");
    controls2.start("visible");
  }  if (inView1) {
    controls1.start("visible");
    // controls2.start("hidden");
  } else {
    controls1.start("hidden");
    controls2.start("hidden");
  }
}, [controls1, controls2, inView1, inView2]);

// Animation variants for about-1
const about1Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.7, 
      ease: "easeInOut", 
    },
  },
};

// Animation variants for about-2
const about2Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.2,
      ease: "easeInOut",
    },
  },
};


  return (
    <div className="about-my-work">
      <motion.span ref={ref1} initial="hidden" animate={controls1} variants={about1Variants}>
        <p
          className="text-5xl"
          style={{
            background: "linear-gradient(253.58deg, #FFE066 1.55%, #FFC300 66.84%)",
            WebkitBackgroundClip: "text", // Chrome, Safari, Opera
            WebkitTextFillColor: "transparent", // Chrome, Safari, Opera
            MozBackgroundClip: "text", // Firefox
            MozTextFillColor: "transparent", // Firefox
            backgroundClip: "text", // Standard (not widely supported yet)
            textFillColor: "transparent", // Standard (not widely supported yet)
          }}
        >
          About My Work
        </p>
      </motion.span>
      <motion.span ref={ref2} initial="hidden" animate={controls2} variants={about2Variants}>
        <p className="text-2xl">Over 10+ Projects ideated and contributed to, showcasing my web-design, frontend and knack of backend technologies.</p>
      </motion.span>
    </div>
  );
}

export default AboutWork